import React from "react";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import CTextField from "uis/CTextField";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import { FormControlLabel } from "material-ui/Form";
import Checkbox from "material-ui/Checkbox";

import ErrorMessage from "components/ErrorMessage";

const styles = theme => {
  return {
    dialogContent: {
      width: 700
    },
    errorMessage: {
      fontSize: ".9rem"
    },
    button: {
      margin: theme.spacing.unit
    }
  };
};

const AdminModal = props => {
  const { classes, adminModal } = props;
  const { open, admin, errors } = adminModal;

  return (
    <Dialog open={open}>
      <DialogTitle id="form-dialog-title">
        管理者{admin.isNew() ? "登録" : "編集"}
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <ErrorMessage messages={errors} className={classes.errorMessage} />

        <CTextField
          id="admin-key"
          label="管理者ID"
          value={admin.adminKey}
          onChange={e => props.changeForm("adminKey", e.target.value)}
          required
          margin="dense"
        />
        <br />
        <CTextField
          id="admin-name"
          label="管理者名"
          value={admin.adminName}
          onChange={e => props.changeForm("adminName", e.target.value)}
          required
          margin="dense"
        />
        <br />
        <CTextField
          id="email"
          label="メールアドレス"
          value={admin.mail}
          onChange={e => props.changeForm("mail", e.target.value)}
          required
          fullWidth
          margin="dense"
        />
        <br />
        <FormControlLabel
          control={
            <Checkbox
              checked={admin.invalidFlg}
              onChange={e => props.changeForm("invalidFlg", e.target.checked)}
            />
          }
          label="無効とする"
        />
        <br />
        {admin.invalidFlg && (
          <CTextField
            id="invalid-reason"
            label="無効理由"
            value={admin.invalidReason || ""}
            onChange={e => props.changeForm("invalidReason", e.target.value)}
            fullWidth
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button raised onClick={props.handleClose}>
          キャンセル
        </Button>
        <Button
          raised
          onClick={() => {
            return admin.isNew()
              ? props.handleRegister(admin)
              : props.handleUpdate(admin);
          }}
        >
          {admin.isNew() ? "登録" : "更新"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(AdminModal);



// WEBPACK FOOTER //
// ./src/components/AdminList/AdminModal.jsx